import BaseApi from '../base/base'
import UserTrackingData from '../../models/user_tracking_data'
import { Tracking } from '../../models/activity_data'

export default class TrackingApi extends BaseApi {
  constructor() {
    super()
    this.path = '/trackings'
  }

  async get(params = {}) {
    this.path = '/trackings'
    const response = await this.getRequest(params)
    return new UserTrackingData(response.data)
  }

  async updateTracking(id, totalRecordedValue, date: string | null = null) {
    this.path = `/trackings/${id}/update_tracking`
    const response = await this.postRequest({
      id,
      totalRecordedValue,
      date
    })
    return new Tracking(response.data)
  }
}
